var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowPageLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8472",
    "data-name": "Caminho 8472",
    d: "M7.712,7.144l-6.034,5.59a1.038,1.038,0,0,1-1.39,0,.864.864,0,0,1,0-1.287L5.627,6.5.288,1.554a.864.864,0,0,1,0-1.287,1.039,1.039,0,0,1,1.39,0l6.034,5.59a.864.864,0,0,1,0,1.287Z",
    transform: "translate(8 13) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPageLeft);
export default __webpack_public_path__ + "static/media/arrowPageLeft.00b217a8a64059104bb4deff475c86dc.svg";
export { ForwardRef as ReactComponent };